module.exports = __webpack_public_path__ + "static/media/ico_window.79a23b5d.svg";